import { stringify, parse } from "flatted";
import { canUseCookie } from "./cookie";

export enum SESSION_STORAGE_KEY {
  AUTH_TOKEN = "AUTH_TOKEN",
  LAST_ACTIVITY_TIME = "LAST_ACTIVITY_TIME",
  LAST_PATH = "LAST_PATH",
  LAST_NAVIGATE_STATE = "LAST_NAVIGATE_STATE",
  AUTH_REFRESH_TOKEN = "AUTH_REFRESH_TOKEN",
  CANDIDATE_PROFILE = "CANDIDATE_PROFILE",
  LAST_AUTH_TOKEN = "LAST_AUTH_TOKEN",
  USER_NAME = "USER_NAME",
  infoFormLang = "infoFormLang",
}

export function getItem<T>(key: string, toJSON: boolean = true): T | null {
  /** need to check first. local-storage Access is denied when disabling cookie */
  if (!canUseCookie()) {
    return null;
  }
  try {
    if (typeof window === "undefined" || !sessionStorage) return null;

    // @ts-ignore
    const rawData = sessionStorage.getItem(key) || "";
    if (!rawData) {
      return null;
    }

    return toJSON ? parse(rawData) : rawData;
  } catch (err) {
    console.error(`sessionStorage getItem ${key} error`, err);
  }
  return null;
}

export function setItem<T>(key: string, item: T) {
  /** need to check first. local-storage Access is denied when disabling cookie */
  if (!canUseCookie()) {
    return null;
  }
  try {
    if (typeof window === "undefined" || !sessionStorage) return null;
    const value = typeof item === "object" ? stringify(item) : (item as string);
    return sessionStorage.setItem(key, value);
  } catch (err) {
    console.error(`sessionStorage setItem ${key} error`, err);
  }
}

export function removeItem(key: string) {
  if (typeof window === "undefined" || !sessionStorage) return null;

  try {
    return sessionStorage.removeItem(key);
  } catch (err) {
    console.error(`sessionStorage remove ${key} error`, err);
  }
}

export const resetLoginSession = () => {
  const preservedKeys: string[] = ["LAST_NAVIGATE_STATE", "LAST_PATH", "infoFormLang", "USER_NAME"];
  const allKeys = Object.keys(sessionStorage);
  allKeys.forEach((key) => {
    if (!preservedKeys.includes(key)) {
      sessionStorage.removeItem(key);
    }
  });
};